import { msg } from 'gt-react';
import { createRoute } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import {
  Route as pathlessAuthenticatedRoute,
  requirePermission,
} from '../route';
import { IntegrationDetailPage } from './IntegrationDetailPage';
import { getIntegrationConfig } from 'src/config/integrations';
import { IntegrationKey } from '@erp/rpc';
import z from 'zod';

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/integrations/$integrationKey',
  staticData: {
    app: {
      access: {
        permissionsAnyOf: [
          { action: Action.Read, subject: Subject.Integration },
        ],
      },
    },
  },
  component: IntegrationDetailPage,
  params: z.object({
    integrationKey: z.enum(IntegrationKey),
  }),
  loader: ({ params }) => {
    const integrationKey = params.integrationKey;
    const config = getIntegrationConfig(integrationKey);
    return {
      crumb: config.name,
      crumbAncestors: [
        {
          title: msg('Integrations', { context: 'page breadcrumb' }),
          path: '/integrations',
        },
      ],
    };
  },
  beforeLoad: async ({ context }) => {
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.Integration,
      redirectTo: '/',
    });
  },
});
